import { createRoot } from "react-dom/client";
import React, { useState } from "react";
import styles from "./SearchBox.module.scss";
import { X } from 'react-bootstrap-icons';
import { MagnifierIcon, XIcon } from "../../Interfaces/Icons";

interface SearchBoxProps {
  placeholderText: string;
  redirectUrl: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ placeholderText, redirectUrl }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (redirectUrl) {
        window.location.href = `${redirectUrl}#state={"q":"${encodeURIComponent(searchTerm)}"}`;
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
    };

    const handleClearButtonClick = () => {
        setSearchTerm("");
    }

  return (
    <section id="search-box-container" className={`${styles["search-box-container"]} section`}>
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row">
          <div className="col-lg mx-auto">
            <div className={styles["search-form-wrapper"]} data-aos="fade-up" data-aos-delay="100">
              <div className="row gx-3">
                <div className="col-12">
                  <div className="form-group">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={placeholderText}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeyPress}
                      ></input>
                      {searchTerm && (
                        <><button
                            type="button"
                            className="btn btn-clear"
                            onClick={handleClearButtonClick}>
                            <XIcon />
                        </button>
                        <span className="btn-seperator"></span>
                        </>
                      )}
                      <button type="button" className="btn btn-primary" onClick={handleSearch} disabled={searchTerm.length == 0 || redirectUrl == null}>
                        <MagnifierIcon />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchBox;

var elements = document.querySelectorAll('[id^="SearchBoxComponent-"]');
for (var i = 0; i < elements.length; i++) {
  var rootElement = document.getElementById(elements[i].id);
  var root = createRoot(rootElement);

  root.render(
    <SearchBox
      placeholderText={rootElement.getAttribute("component-placeholder")}
          redirectUrl={rootElement.getAttribute("component-redirectUrl")}
    />
  );
}
